import React from 'react';

const AboutPage = () => {
  const styles = {
    subPage: {
      minHeight: 'calc(100vh - 70px)',
      paddingBottom: '60px',
    },
    subPageHeader: {
      backgroundColor: '#2563eb',
      color: '#ffffff',
      padding: '80px 20px',
      textAlign: 'center',
    },
    subPageTitle: {
      fontSize: '48px',
      fontWeight: 'bold',
      marginBottom: '10px',
    },
    subPageSubtitle: {
      fontSize: '18px',
      color: '#dbeafe',
    },
    container: {
      maxWidth: '1200px',
      margin: '0 auto',
    },
    aboutSection: {
      padding: '60px 20px',
    },
    aboutTitle: {
      fontSize: '28px',
      fontWeight: 'bold',
      marginBottom: '30px',
      color: '#1f2937',
      borderBottom: '4px solid #2563eb',
      paddingBottom: '10px',
    },
    aboutText: {
      fontSize: '16px',
      lineHeight: '1.8',
      color: '#4b5563',
    },
    companyTable: {
      width: '100%',
      borderCollapse: 'collapse',
    },
    tableRow: {
      borderBottom: '1px solid #e5e7eb',
    },
    tableHeader: {
      backgroundColor: '#f9fafb',
      padding: '20px',
      textAlign: 'left',
      //width: '300px',
      fontWeight: 'bold',
      color: '#374151',
    },
    tableData: {
      padding: '20px',
      color: '#4b5563',
      textAlign: 'left',
    },
    historyList: {
      marginTop: '20px',
    },
    historyItem: {
      display: 'flex',
      marginBottom: '25px',
      paddingBottom: '25px',
      borderBottom: '1px solid #e5e7eb',
    },
    historyYear: {
      fontSize: '18px',
      fontWeight: 'bold',
      color: '#2563eb',
      minWidth: '150px',
    },
    historyContent: {
      fontSize: '16px',
      color: '#4b5563',
      textAlign: 'left',
      marginLeft: '20px',
    },
  };

  return (
    <div style={styles.subPage}>
      <style>
        {`
          @media (max-width: 768px) {
            .sub-page-header-about-mobile {
              padding: 60px 20px !important;
            }
            .sub-page-title-about-mobile {
              font-size: 36px !important;
            }
            .sub-page-subtitle-about-mobile {
              font-size: 16px !important;
            }
            .about-section-mobile {
              padding: 40px 15px !important;
            }
            .about-title-mobile {
              font-size: 24px !important;
            }
            .about-text-mobile {
              font-size: 15px !important;
            }
            .company-table-mobile {
              display: block !important;
            }
            .company-table-mobile tbody {
              display: block !important;
            }
            .table-row-mobile {
              display: block !important;
              margin-bottom: 20px !important;
            }
            .table-header-mobile {
              display: block !important;
              width: 200px !important;
              padding: 12px 10px !important;
              font-size: 13px !important;
            }
            .table-data-mobile {
              display: block !important;
              padding: 12px 10px !important;
              background-color: #ffffff !important;
              font-size: 13px !important;
            }
            .history-item-mobile {
              flex-direction: column !important;
            }
            .history-year-mobile {
              font-size: 16px !important;
              min-width: auto !important;
              margin-bottom: 10px !important;
              text-align: left !important;
            }
            .history-content-mobile {
              margin-left: 0 !important;
              font-size: 14px !important;
            }
          }
        `}
      </style>
      <div style={styles.subPageHeader} className="sub-page-header-about-mobile">
        <h1 style={styles.subPageTitle} className="sub-page-title-about-mobile">ABOUT</h1>
        <p style={styles.subPageSubtitle} className="sub-page-subtitle-about-mobile">会社情報</p>
      </div>
      <div style={styles.container}>
        <section style={styles.aboutSection} className="about-section-mobile">
          <h2 style={styles.aboutTitle} className="about-title-mobile">会社概要</h2>
          <table style={styles.companyTable} className="company-table-mobile">
            <tbody>
              <tr style={styles.tableRow} className="table-row-mobile">
                <th style={styles.tableHeader} className="table-header-mobile">会社名</th>
                <td style={styles.tableData} className="table-data-mobile">株式会社J・T・C (旧:株式会社カオスゲート)</td>
              </tr>
              <tr style={styles.tableRow} className="table-row-mobile">
                <th style={styles.tableHeader} className="table-header-mobile">商号</th>
                <td style={styles.tableData} className="table-data-mobile">旅人倶楽部</td>
              </tr>
              <tr style={styles.tableRow} className="table-row-mobile">
                <th style={styles.tableHeader} className="table-header-mobile">取締役社長</th>
                <td style={styles.tableData} className="table-data-mobile">慶田 忠吉</td>
              </tr>
              <tr style={styles.tableRow} className="table-row-mobile">
                <th style={styles.tableHeader} className="table-header-mobile">資本金</th>
                <td style={styles.tableData} className="table-data-mobile">1,000万円</td>
              </tr>
              <tr style={styles.tableRow} className="table-row-mobile">
                <th style={styles.tableHeader} className="table-header-mobile">大阪営業所</th>
                <td style={styles.tableData} className="table-data-mobile">〒530-0041 大阪市北区天神橋3丁目2番15号 サクシード南森町</td>
              </tr>
              <tr style={styles.tableRow} className="table-row-mobile">
                <th style={styles.tableHeader} className="table-header-mobile">許認可</th>
                <td style={styles.tableData} className="table-data-mobile">大阪府知事登録旅行サービス手配業 第7598号</td>
              </tr>
              <tr style={styles.tableRow} className="table-row-mobile">
                <th style={styles.tableHeader} className="table-header-mobile">取引銀行</th>
                <td style={styles.tableData} className="table-data-mobile">みずほ銀行 東大阪支店 / 三菱UFJ銀行 鴻池新田支店</td>
              </tr>
              <tr style={styles.tableRow} className="table-row-mobile">
                <th style={styles.tableHeader} className="table-header-mobile">旅行サービス手配業務取扱管理者</th>
                <td style={styles.tableData} className="table-data-mobile">田端 真悟</td>
              </tr>
              <tr style={styles.tableRow} className="table-row-mobile">
                <th style={styles.tableHeader} className="table-header-mobile">事業内容</th>
                <td style={styles.tableData} className="table-data-mobile">
                  訪日インバウンド旅行手配事業<br/>
                </td>
              </tr>
            </tbody>
          </table>
        </section>

        <section style={styles.aboutSection} className="about-section-mobile">
          <h2 style={styles.aboutTitle} className="about-title-mobile">企業理念</h2>
          <p style={styles.aboutText} className="about-text-mobile">
            1.お客様に喜びと感動を与えつづける企業をめざします。
          </p>
          <p style={styles.aboutText} className="about-text-mobile">
            2.社員として働き甲斐のある職場づくりと社員の幸福をめざします。
          </p>
        </section>

        
      </div>
    </div>
  );
};

export default AboutPage;